import React from "react";
import Text from "../../Text";
import Loading from "../../Loading";
import Row from "../Row";
import Column from "../Column";

export default (props) => {
  if (props.loading) {
    return <Loading />;
  } else {
    return (
      <div {...props} className="container-fluid py-4">
        {props.title ? (
          <Row>
            <Column col="12">
              <Text fontSize="md">{props.title}</Text>
            </Column>
          </Row>
        ) : (
          <React.Fragment />
        )}
        {props.children}
      </div>
    );
  }
};



// WEBPACK FOOTER //
// ./src/_components/Layout/Page/index.jsx